// Adds a callback to window scroll
export const scrollView = (target: any, options:any, callback: () => void) => {
    // console.log('offset ', offset);
    // console.log('scrollHeight ', document.documentElement.scrollHeight)
    // console.log('window.', window.innerHeight);
    const onScroll = function () {
        window.removeEventListener('scroll', onScroll);
        callback()
    }

    window.addEventListener('scroll', onScroll)
    onScroll()
    target.scrollIntoView({...options})
}
